import {WRAPPER_Z_INDEX} from './PanAndZoomImageCanvas';
import CheckCircle from '../design_system/icon/CheckCircle';
import {ContentColor} from '../design_system/theme/useContentPalette';
import Typography, {Size} from '../design_system/typography/Typography';

import {css} from '@emotion/react';
import React from 'react';

export interface Props {
  readonly 'data-testid'?: string;
  readonly label?: React.ReactNode;
}

export default function SuccessOverlay(props: Props): JSX.Element {
  const {label} = props;
  return (
    <div
      css={css({
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: WRAPPER_Z_INDEX + 10,
        userSelect: 'none',
      })}
      data-testid={props['data-testid']}
    >
      <CheckCircle
        color={ContentColor.PRIMARY}
        size={32}
      />
      <Typography size={Size.L}>{label}</Typography>
    </div>
  );
}
